var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoleOperation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.84 14C24.84 20.2629 19.7629 25.34 13.5 25.34C7.23709 25.34 2.16 20.2629 2.16 14C2.16 7.73709 7.23709 2.66 13.5 2.66C19.7629 2.66 24.84 7.73709 24.84 14ZM27 14C27 21.4558 20.9558 27.5 13.5 27.5C6.04416 27.5 0 21.4558 0 14C0 6.54416 6.04416 0.5 13.5 0.5C20.9558 0.5 27 6.54416 27 14ZM16.6786 6.83333C16.6786 7.56971 15.9857 8.16667 15.131 8.16667C14.2762 8.16667 13.5833 7.56971 13.5833 6.83333C13.5833 6.09695 14.2762 5.5 15.131 5.5C15.9857 5.5 16.6786 6.09695 16.6786 6.83333ZM13.2429 8.75333C14.0167 8.51333 14.8369 8.83333 15.1929 9.46C16.4774 11.7267 18.3655 12.1667 19 12.1667V13.5C17.9167 13.5 15.8893 12.78 14.4964 11.1533L13.8619 14.2867L15.9048 16.2067V21.5H14.3571V16.7267L12.6238 15.1133L11.819 18.6333L6 17.6067L6.30952 16.3L10.6119 17.06L12.0976 10.54L9.71429 11.3V13.5H8.16667V10.3667L13.2429 8.75333Z",
    fill: "#767B9B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoleOperation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/role_operation.237bfd5738b3be8f133624c489af9bbd.svg";